module.exports = __webpack_public_path__ + "assets/img/weight.f980f2b2.png";